import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Navbar from '../components/Navbar';
import './CustomerList.css';
import { useNavigate } from 'react-router-dom';

const PAGE_SIZE = 5;

const CustomerList = () => {
  const [customers, setCustomers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  const fetchCustomers = () => {
    api.get('/customers')
      .then(res => {
        const sorted = res.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setCustomers(sorted);
      })
      .catch(err => console.error('Error fetching customers:', err));
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  const handleDelete = (id) => {
    const confirmed = window.confirm('Are you sure you want to delete this customer?');
    if (confirmed) {
      api.delete(`/customers/${id}`)
        .then(() => {
          fetchCustomers(); // Refresh list
        })
        .catch(err => {
          console.error('Error deleting customer:', err);
          alert('Failed to delete customer.');
        });
    }
  };

  const handleEdit = (id) => {
    navigate(`/customers/edit/${id}`);
  };

  const totalPages = Math.ceil(customers.length / PAGE_SIZE);
  const paginatedCustomers = customers.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  return (
    <> <Navbar /> 
    <div className="customer-container">
     
      <div className="customer-header">
        <h2>Customer List</h2>
        <button className="add-btn" onClick={() => navigate('/customers/new')}>
          + Add Customer
        </button>
      </div>

      <div className="table-responsive">
        <table className="customer-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>City</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedCustomers.map((c, index) => (
              <tr key={c.id}>
                <td>{(currentPage - 1) * PAGE_SIZE + index + 1}</td>
                <td>{c.customername}</td>
                <td>{c.city}</td>
                <td>{c.email || 'N/A'}</td>
                <td>{c.phone || 'N/A'}</td>
                <td>
                  <button className="edit-btn" onClick={() => handleEdit(c.id)}>Edit</button>
                  <button className="delete-btn" onClick={() => handleDelete(c.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)}>Previous</button>
        <span>Page {currentPage} of {totalPages}</span>
        <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>
      </div>
    </div>
    </>
  );
};

export default CustomerList;
